import { Accordion, Container } from "react-bootstrap";
import useTranslator from "../../../hooks/useTranslator";
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import TenantContext from "../../../context/tenant/TenantContext";
import { haveValue } from "../../../helper/common";

const GuarantorAddedDetails = (props) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { guarantorId } = useParams();
  const { guarantorAddedDetails, fetchTenantDocs } = useContext(TenantContext);
  const [guarantorDetails, setGuarantorDetails] = useState({});
  const [allDocs, setAllDocs] = useState([]);

  useEffect(() => {
    guarantorAddedDetails(guarantorId)
      .then((res) => {
        setGuarantorDetails(res.success_res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    fetchTenantDocs(guarantorDetails?.guarantor_id?._id, false, true)
      .then((res) => {
        console.log(res);
        const data = res.data.success_res.tenantDocs;
        const temp_docs = new Map();
        data.map((doc) => {
          if (!temp_docs.has(doc?.type)) {
            temp_docs.set(doc?.type, doc);
          }
        });

        setAllDocs(temp_docs);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [guarantorDetails]);

  const goBackGuarantor = () => {
    navigate("/tenant/connectBank");
  };

  const handleNavigateEdit = () => {
    console.log(allDocs);
    navigate(`/edit/guarantor/${guarantorId}`);
  };

  const handleNavigateTenantDocs = () => {
    navigate(`/edit/guarantor/docs/${guarantorId}`);
  };

  return (
    <>
      <div className="step-form-main-wrapper">
        <div className="d-flex step-absolute-header step-form-header">
          <Container className="p-0 text-center back-btn">
            <div className="">
              <a href={undefined} onClick={goBackGuarantor}>
                <img src="/images/back-btn-white.svg" alt="" />
              </a>
            </div>
          </Container>
          <h3 class="step-form-name mobile-model-heading">
            <img src="/images/profile-icon.svg" alt="" />
            <span>{_t("guarantorDetails")}</span>
          </h3>
        </div>
        <Accordion className="primaryaccordion d-md-grid mobile-primary-accordaion">
          <Accordion.Item eventKey="0" id="divToPrint">
            <div className="withdownloadbtn">
              <Accordion.Header className="primaryaccordion-header setaccordionhead  ">
                <div className="d-flex justify-content-between w-100 score_profile_div">
                  <span className="maintitle">
                    {guarantorDetails?.gurantor_name ?? ""}
                  </span>
                </div>
              </Accordion.Header>
            </div>
            <Accordion.Body className="primaryaccordion-body paddingTop0">
              <div
                className="d-flex row guarantorDetailsWrapper"
                style={{
                  background: "#EFF9E4",
                  padding: "1.667vw",
                  borderRadius: "0.833vw",
                  margin: "0.361vw 0",
                }}
              >
                <div className="col-sm-3">
                  <label className="grey-text" htmlFor="">
                    {_t("relationshipWithGuarantor")}
                  </label>
                  <p>{guarantorDetails?.gurantor_relation ?? ""}</p>
                </div>
                <div className="col-sm-3">
                  <label className="grey-text" htmlFor="">
                    {_t("guarantorEmail")}
                  </label>
                  <p>{guarantorDetails?.gurantor_email ?? ""}</p>
                </div>
                <div className="col-sm-3">
                  <label className="grey-text" htmlFor="">
                    {_t("employmentStatus")}
                  </label>
                  <p>
                    {_t(guarantorDetails?.guarantor_id?.employment_status) ??
                      ""}
                  </p>
                </div>
                {haveValue(
                  guarantorDetails?.guarantor_id?.employment_category
                ) && (
                  <div className="col-sm-3">
                    <label className="grey-text" htmlFor="">
                      {_t("employmentCategory")}
                    </label>
                    <p>
                      {_t(
                        guarantorDetails?.guarantor_id?.employment_category
                      ) ?? ""}
                    </p>
                  </div>
                )}
                <div className="col-sm-3">
                  <label className="grey-text" htmlFor="">
                    {_t("titleForProtectedHousing")}
                  </label>
                  <p>
                    {guarantorDetails?.guarantor_id?.protected_housing
                      ? _t("yes")
                      : _t("no")}
                  </p>
                </div>
                <div className="col-sm-3">
                  <label className="grey-text" htmlFor="">
                    {_t("annualIncome")}
                  </label>
                  <p>{guarantorDetails?.guarantor_id?.current_annual_income}</p>
                </div>
              </div>
              <div style={{ marginTop: "1vw" }}>
                <button
                  className="btn btngrey score-below-btn gap-2 dakstop-scorebtn editBtn"
                  style={{ padding: "0.417vw 0.833vw" }}
                  onClick={handleNavigateEdit}
                >
                  <img src="/images/edit-icon.svg" alt="Edit" />
                  {_t("editGuarantor")}
                </button>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div className="big_tablebg tenant-doc-tile">
          <div className="border-pd">
            <ul>
              <li
                className="d-flex tile-design border-0 p-0 m-0 cursor-pointer"
                onClick={handleNavigateTenantDocs}
              >
                <div className="tile-content-wrapper">
                  <div className="tile-content">
                    <h4 className="tile-heading">{_t("documents")}</h4>
                  </div>
                  <div className="d-flex align-items-center gap-24">
                    {/* <div className="d-flex align-items-center gap-4 tile-btns-wrapper">
                      <button className="btn btngreen">
                        {_t("addMoreDocuments")}
                      </button>
                    </div> */}
                    <p>
                      {allDocs.size ?? 0} {_t("documents")}
                    </p>
                    <a href="#">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="19"
                        viewBox="0 0 11 19"
                        fill="none"
                      >
                        <path
                          d="M1 18L10 9.5L1 1"
                          stroke="#121212"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuarantorAddedDetails;
